import { render, staticRenderFns } from "./WPickupConfirmBonos.vue?vue&type=template&id=3e0d6d88&"
import script from "./WPickupConfirmBonos.vue?vue&type=script&lang=js&"
export * from "./WPickupConfirmBonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WInput from '@/components/WInput.vue'
import WLoading from '@/components/WLoading.vue'
import WTextarea from '@/components/WTextarea.vue'
autoInstallComponents(component, {WInput,WLoading,WTextarea})
